import React from 'react';
import { createCommand } from '@commander-js/extra-typings';
import type { AstroCommandServices } from '@wix/cli-command-contract';

export const connectCommand = (
  services: AstroCommandServices,
  cliVersion: string
) => {
  return createCommand('connect')
    .description('Connect your project to GitHub to enable Wix Vibe editing')
    .action(async (options, command) => {
      const { renderCommand } = await import('./render-command.js');
      const { ConnectWixVibeCommand } = await import(
        '../components/ConnectWixVibeCommand/index.js'
      );

      await renderCommand(
        command,
        services,
        cliVersion,
        <ConnectWixVibeCommand />
      );
    });
};
